<script>
	export let items;
	export let val = 0;
	
	$: item = items[val];
	
	function increment() {
		if (val < items.length-1) {
			val++;
		}
	}
	
	function decrement() {
		if (val > 0) {
			val--;
		}
	}
</script>

<div class="step-select">
	<button class="icon" disabled={val <= 0} id="decrease" on:click={decrement}>
		<img src="img/minus.svg" alt="Decrease" title="Decrease" />
		<span>Decrease</span>
	</button>

	<div class="output">
		{#if item.img}
		<img src="{item.img}" alt="{item.name}" />
		{/if}
		<span>{item.name}</span>
	</div>

	<button class="icon" disabled={val >= items.length-1} id="increase" on:click={increment}>
		<img src="img/plus.svg" alt="Increase" title="Increase" />
		<span>Increase</span>
	</button>
</div>

<style>
	div.step-select {
		display: flex;
		align-items: center;
		margin-bottom: 1rem;
	}
	
	.step-select .output {
		padding: 0.25rem 1rem;
		flex-grow: 2;
		display: flex;
		align-items: center;
		justify-content: center;
		
	}

	.step-select .output img {
		margin-right: 0.5rem;
	}
</style>